import script from "./TabPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./TabPanel.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__